export default {
  getCoachTasks(state) {
    return state.tasks;
  },
  getCoachTaskTickets(state) {
    return state.taskTickets;
  },
};
